import './App.css';

import AppImage from './AppImage';
import TopToolbar from './components/TopToolbar';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { useSiteI18n } from './i18n/siteI18n';

function Support() {
  const navigate = useNavigate();
  const { t } = useSiteI18n();

  const gotoHome = () => {
    navigate('/');
  };

  return (
    <div className="App">
      <Helmet>
        <title>{t('supportPageTitle')}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="App-content">
        <TopToolbar showBack onBack={gotoHome} />
        <a href="/" onClick={gotoHome}>
          <img src="/img/mnf-white.png" className="App-logo" alt="logo" />
        </a>
        <AppImage
          image="/img/support.png"
          name="Support"
          containerClassName="App-support-image-box"
          imageClassName="App-support-image"
        />
      </div>
      <footer className="App-support">
        {t('supportContact')}{' '}
        <a href='mailto:"My Nature Friends Support"<support@mynaturefriends.me>'>
          support
          <span className="App-support-at">
            <img
              src="/img/at_sign.png"
              alt="@"
              style={{ width: 16, paddingLeft: 2, paddingRight: 2 }}
            />
          </span>
          mynaturefriends.me
        </a>
      </footer>
    </div>
  );
}

export default Support;
